export function overflowitemRender() { return `<div style="${  this.__$objToStyleMap(this.overFlowItemStyle)  }" aria-disabled="${ this.disabled }" role="menuitem" tabindex="-1" class="${  this.disabled==true ? 'disabled': ''  } " ld--elist="click" ld-on-click="onMenuClick">
    <img src="${ this.imgUrl }" aria-hidden="true">
    <span>${ this.text }</span>
</div>
`  }